import {SOPutView} from '../../core/view/so-put-view';
import {ViewCore} from './view.core';
import {SOGetView} from '../../core/view/so-get-view';
import {FormField, SelectionOption} from 'lionheartland';
import {putViewFormFieldOptions} from './put-view-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';

export class RAPutView extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putViewFormFieldOptions);

  RequestClass = SOPutView

  constructor(
    public entityCore: ViewCore
  ) {
    super();
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('identifier'),
      this.getFormValueFromIdentifier('type'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}